import { Button, DialogActions, DialogContent, DialogTitle } from "@mui/material"
import Input from "components/controls/input"
import { useDialogStore } from "dialogs"
import { autorun } from "mobx"
import { observer } from "mobx-react-lite"
import { useEffect } from "react"
import { useMainStore } from "store"
import Content from "store/content"
import Project from "store/project"
import { useForm } from "utils/use-form"
import useKeyDown from "utils/use-key-down"

const NewSiteDialog = observer(({ copyProject }: { copyProject?: Project }) => {

  const mainStore = useMainStore()
  const dialog = useDialogStore()
  const form = useForm({
    name: copyProject?.name || "",
    slug: copyProject?.slug || ""
  })
  const disabled = !form.get("name") || !form.get("slug")

  useKeyDown({
    "Enter": () => apply()
  }, [ disabled ])

  useEffect(() => autorun(() => {
    const slug = form.get("slug")
    if (!slug) return
    const _slug = slug.replace(/[^a-zA-Z0-9]/g, '')
    form.set("slug", _slug)
  }), [])

  const apply = () => {
    if (disabled) return false
    const project = new Project()
    project.name = form.get("name") || ""
    project.slug = form.get("slug") || ""
    mainStore.addProject(project)
    mainStore.selectProject(project.id)
    
    if (copyProject) {
      for (let content of copyProject.contents.values()) {
        const newContent = new Content(content.schemeId)
        newContent.name = content.name
        newContent.data.sectionId = content.data.sectionId
        newContent.data.values = JSON.parse(JSON.stringify(content.data.values))
        project.addContent(newContent)
        mainStore.saveContent(newContent)
      }
      mainStore.saveProject(project)
    }

    dialog.close()
    return true
  }

  return (
    <>
      <DialogTitle>
        { copyProject? "Дублирование сайта": "Добавление сайта" }
      </DialogTitle>
      <DialogContent sx={{ width: 450, "&>*:not(:last-child)": { mb: 0.5 } }}>
        <Input autoFocus {...form.getProps("name")} label="Название" placeholder="Новый сайт" />
        <Input {...form.getProps("slug")} label="Slug сайта" placeholder="Пустое значение" />
      </DialogContent>
      <DialogActions>
        <Button disabled={disabled} variant="contained" color="secondary" sx={{ px: 6 }} onClick={apply}>
        { copyProject? "Дублировать сайт": "Добавить сайт" }
        </Button>
      </DialogActions>
    </>
  )
})

export default NewSiteDialog